import { pluralize } from "@theprelude/core";

export const ResultCount = ({
  count,
  totalCount,
  resourceType,
  loading = false,
}: {
  count: number;
  totalCount: number;
  resourceType: string;
  loading?: boolean;
}) => {
  const pluralResourceType = resourceType === "inbox" ? "inboxes" : undefined;
  const resourcesType = pluralize(2, resourceType, pluralResourceType);

  return (
    <div className="text-xs">
      {loading ? (
        <div className="h-2 w-24 animate-pulse rounded-md bg-secondary-background" />
      ) : (
        <>
          {(count > 0 ? 1 : 0).toLocaleString()}-{count.toLocaleString()} of{" "}
          <span data-testid={`scm-list-${resourcesType}-count`}>
            {totalCount.toLocaleString()}
          </span>{" "}
          {pluralize(totalCount, resourceType, pluralResourceType)}
        </>
      )}
    </div>
  );
};
